// src/components/Footer.js

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../css/Footer.css";
import googlePlay from "../../images/google-play.png";
import appStore from "../../images/app-store.png";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettings } from "../../redux/settingsSlice";
import bgBox from "../../images/bgBox.png";
import Cookies from "js-cookie";
import dreamLogo from "../../images/Homepage/sa-logo.png";
import instagram1 from "../../images/instagram/property-detail-1.webp";
import instagram2 from "../../images/instagram/property-detail-2.webp";
import instagram3 from "../../images/instagram/property-detail-3.webp";
import instagram4 from "../../images/instagram/property-detail-4.webp";
import instagram5 from "../../images/instagram/property-detail-5.webp";
import instagram6 from "../../images/instagram/property-gf-1.webp";
import instagram7 from "../../images/instagram/property-ls-1.webp";
import instagram8 from "../../images/instagram/siddiananta-events-1.webp";
import instagram9 from "../../images/instagram/siddiananta-events-main.webp";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const { settingsData, status, error1 } = useSelector(
    (state) => state.settings
  );

  // Handle email input change
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  // Handle newsletter subscription form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple email validation
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailPattern.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/subscribeNewsLetter`,
        {
          email,
        }
      );

      const { status, message } = response.data;

      if (status) {
        setError("");
        setIsSubscribed(true);
        setEmail("");
      } else {
        // Handle already subscribed or other soft errors
        setError(message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Subscription error:", error);

      // Handle various error status codes
      const statusCode = error.response?.status;

      let fallbackMessage = "An error occurred. Please try again later.";
      if (statusCode === 400) {
        fallbackMessage = "Email is required or invalid format.";
      } else if (statusCode === 422) {
        fallbackMessage = "Validation failed. Please check the email.";
      } else if (statusCode === 500) {
        fallbackMessage = "Internal server error. Please try again later.";
      } else if (statusCode === 404) {
        fallbackMessage = "API endpoint not found.";
      } else if (error.response?.data?.message) {
        fallbackMessage = error.response.data.message;
      }

      setError(fallbackMessage);
    }
  };

  // Function to clear browser cache (cookies, localStorage, sessionStorage) and reload app
  const clearAppCache = () => {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
    // Clear localStorage and sessionStorage
    localStorage.clear();
    sessionStorage.clear();
    // Force reload to refresh images, styles, scripts, etc.
    window.location.reload(true); // true = force reload from server (image cache busted)
  };

  // useEffect to fetch settings data when component mounts (if not already loaded)
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchSettings());
    }
  }, [dispatch, status]);

  // useEffect to compare current app version and clear cache if version changed
  useEffect(() => {
    const currentVersion = settingsData?.app_version;
    if (currentVersion) {
      const previousVersion = Cookies.get("app_version");
      // If no version cookie exists OR version has changed → clear and reload
      if (!previousVersion || previousVersion !== currentVersion) {
        clearAppCache(); // This clears cookies, localStorage, etc. and reloads the page
      }
      // Always set the latest version in cookie
      Cookies.set("app_version", currentVersion, { expires: 365 });
    }
  }, [settingsData]);

  if (status === "loading") return <div className="text-center">...</div>;
  if (status === "failed") return <div>Error loading settings: {error1}</div>;
  if (!settingsData) return <div>No settings data available</div>;

  return (
    <footer className="footer">
      <div className="container">
        <div className="row foot-colbox justify-content-between">
          <div className="col-md-3 foot-col1">
            <div className="logos">
              <img src={bgBox} alt="box" className="sp1"></img>
              <Link to="/">
                <img src={dreamLogo} alt="DreamSakha" className="footlogo" />
              </Link>
            </div>
            <p className="foot-abt1">
              At Siddhi Ananta Group, We prioritize quality, convenience, and a
              seamless customer experience, making your journey to home
              ownership smooth and rewarding.
            </p>
            {/* <div>
              <div className="foothead1">Download The App</div>
              <div className="foothdline"></div>
              <div className="appdnlod">
                <Link
                  to={settingsData.playstore_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={appStore} alt="DreamSakha" className="appStore" />
                </Link>
                <Link
                  to={settingsData.playstore_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={googlePlay}
                    alt="DreamSakha"
                    className="googlePlay"
                  />
                </Link>
              </div>
            </div> */}
          </div>
          <div className="col-md-3">
            <div className="foothead">Quick Links</div>
            <div className="foothdline"></div>
            <ul className="footqlinks">
              <li>
                <Link to="/aboutUs">About Us</Link>
              </li>
              <li>
                <Link to="/blogs">Blog</Link>
              </li>
              {/* <li>
                <Link to="/packagePage">Our Pakages</Link>
              </li> */}
              <li>
                <Link to="/contactUs">Contact Us</Link>
              </li>
              <li>
                <Link to="/postProperty">Post Your Property</Link>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
              <li>
                <Link to="/privacypolicy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/term_condition">Terms & Conditions</Link>
              </li>
            </ul>
          </div>
          {/* <div className="col-md-3">
            <div className="foothead2">Instagram feeds</div>
            <div className="foothdline"></div>
            <div className="fb3_2">
              <div className="fb3_3">
                <div className="fb3_4">
                  <img src={instagram1} alt="box" className="instaimgs"></img>
                </div>
                <div className="fb3_4">
                  <img src={instagram2} alt="box" className="instaimgs"></img>
                </div>
                <div className="fb3_4">
                  <img src={instagram3} alt="box" className="instaimgs"></img>
                </div>
              </div>
              <div className="fb3_3">
                <div className="fb3_4">
                  <img src={instagram4} alt="box" className="instaimgs"></img>
                </div>
                <div className="fb3_4">
                  <img src={instagram5} alt="box" className="instaimgs"></img>
                </div>
                <div className="fb3_4">
                  <img src={instagram6} alt="box" className="instaimgs"></img>
                </div>
              </div>
              <div className="fb3_3">
                <div className="fb3_4">
                  <img src={instagram7} alt="box" className="instaimgs"></img>
                </div>
                <div className="fb3_4">
                  <img src={instagram8} alt="box" className="instaimgs"></img>
                </div>
                <div className="fb3_4">
                  <img src={instagram9} alt="box" className="instaimgs"></img>
                </div>
              </div>
            </div>
          </div> */}
          <div className="col-md-3">
            <div className="foothead">Subscribe</div>
            <div className="foothdline"></div>
            <p className="foot-abt sub">
              Sign up for Newsletter to Get all the information on Events,
              Offers, Sales and More.
            </p>
            <div className="fb4_ob">
              <div className="fb4_3">
                {!isSubscribed ? (
                  <>
                    <input
                      type="email"
                      value={email}
                      onChange={handleChange}
                      aria-label="Enter your email"
                      required
                    />
                    <button onClick={handleSubmit}>Subscribe</button>
                  </>
                ) : (
                  <p>You've successfully subscribed to our newsletter!</p>
                )}
              </div>
              {error && <p className="error">{error}</p>}
            </div>
            <div className="foothead">Connect with us @</div>
            <div className="foothdline"></div>
            <div className="connectwus">
              {settingsData?.email && (
                <p>
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_748_16863)">
                      <path
                        d="M6.45661 9.71429L8.87478 7.28936M4.62609 4.76311L10.3608 2.85154C12.9343 1.99369 14.3326 3.39866 13.4815 5.9722L11.5699 11.7069C10.2865 15.5638 8.17905 15.5638 6.89566 11.7069L6.32827 10.0047L4.62609 9.43735C0.769168 8.15396 0.769168 6.05325 4.62609 4.76311Z"
                        stroke="white"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_748_16863">
                        <rect width="15" height="15" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                   <a href={`mailto:${settingsData?.email}`}>
                    <span>{settingsData.email}</span>
                  </a>
                </p>
              )}
              {settingsData?.mobile && (
                <p>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_748_16869)">
                      <path
                        d="M12.3012 10.8957C12.3012 11.0907 12.2579 11.2911 12.1658 11.4861C12.0737 11.6811 11.9545 11.8653 11.7975 12.0386C11.532 12.3311 11.2395 12.5424 10.9091 12.6778C10.5841 12.8132 10.232 12.8836 9.85288 12.8836C9.30038 12.8836 8.70997 12.7536 8.08705 12.4882C7.46413 12.2228 6.84121 11.8653 6.22371 11.4157C5.59436 10.9553 5.00046 10.4484 4.44705 9.89904C3.8993 9.34763 3.3941 8.75552 2.9358 8.12779C2.49163 7.51029 2.13413 6.89279 1.87413 6.28071C1.61413 5.66321 1.48413 5.07279 1.48413 4.50946C1.48413 4.14113 1.54913 3.78904 1.67913 3.46404C1.80913 3.13363 2.01496 2.83029 2.30205 2.55946C2.64871 2.21821 3.02788 2.05029 3.42871 2.05029C3.58038 2.05029 3.73205 2.08279 3.86746 2.14779C4.0083 2.21279 4.13288 2.31029 4.23038 2.45113L5.48705 4.22238C5.58455 4.35779 5.65496 4.48238 5.70371 4.60154C5.75246 4.71529 5.77955 4.82904 5.77955 4.93196C5.77955 5.06196 5.74163 5.19196 5.6658 5.31654C5.59538 5.44113 5.49246 5.57113 5.36246 5.70113L4.9508 6.12904C4.89121 6.18863 4.86413 6.25904 4.86413 6.34571C4.86413 6.38904 4.86955 6.42696 4.88038 6.47029C4.89663 6.51363 4.91288 6.54613 4.92371 6.57863C5.02121 6.75738 5.18913 6.99029 5.42746 7.27196C5.67121 7.55363 5.93121 7.84071 6.21288 8.12779C6.50538 8.41488 6.78705 8.68029 7.07413 8.92404C7.3558 9.16237 7.58871 9.32487 7.77288 9.42237C7.79996 9.43321 7.83247 9.44946 7.87038 9.46571C7.91372 9.48196 7.95705 9.48737 8.0058 9.48737C8.09788 9.48737 8.1683 9.45488 8.22788 9.39529L8.63955 8.98904C8.77497 8.85363 8.90497 8.75071 9.02955 8.68571C9.15413 8.60988 9.27872 8.57196 9.41413 8.57196C9.51705 8.57196 9.62538 8.59363 9.74455 8.64238C9.86372 8.69113 9.9883 8.76154 10.1237 8.85363L11.9166 10.1265C12.0575 10.224 12.155 10.3378 12.2145 10.4732C12.2687 10.6086 12.3012 10.744 12.3012 10.8957Z"
                        stroke="white"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M10.4212 5.84196C10.4212 5.51696 10.1666 5.01863 9.78747 4.61238C9.44081 4.23863 8.98039 3.94613 8.52539 3.94613M12.3171 5.84196C12.3171 3.74571 10.6216 2.05029 8.52539 2.05029"
                        stroke="white"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_748_16869">
                        <rect
                          width="13"
                          height="13"
                          fill="white"
                          transform="translate(0.400391 0.966797)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <a href={`tel:+91${settingsData?.mobile}`}>
                    <span>+91-{settingsData?.mobile}&nbsp;</span>
                  </a>
                </p>
              )}
              {settingsData?.address && (
                <p>
                  <svg
                    width="8"
                    height="14"
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 0.888672C1.77778 0.888672 0 2.66645 0 4.88867C0 7.11089 4 13.3331 4 13.3331C4 13.3331 8 7.11089 8 4.88867C8 2.66645 6.22222 0.888672 4 0.888672ZM4 6.66645C3.02222 6.66645 2.22222 5.86645 2.22222 4.88867C2.22222 3.91089 3.02222 3.11089 4 3.11089C4.97778 3.11089 5.77778 3.91089 5.77778 4.88867C5.77778 5.86645 4.97778 6.66645 4 6.66645Z"
                      fill="white"
                    />
                  </svg>
                  <Link to="/">
                    <span>{settingsData.address}</span>
                  </Link>
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className="row">
            <div className="col-md-6">
              &copy; 2024 {settingsData.name} All rights reserved.
            </div>
            <div className="col-md-6 socialbox">
              <Link
                to={settingsData?.facebook_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="17"
                  height="17"
                  className="socialicon"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_748_16842)">
                    <path
                      d="M13.1885 10.333L13.6884 7.07543H10.5627V4.96148C10.5627 4.07027 10.9993 3.20156 12.3992 3.20156H13.8203V0.428086C13.8203 0.428086 12.5307 0.208008 11.2978 0.208008C8.72366 0.208008 7.04109 1.76824 7.04109 4.5927V7.07543H4.17972V10.333H7.04109V18.208H10.5627V10.333H13.1885Z"
                      fill="#141414"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_748_16842">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0 0.208008)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </Link>

              <Link
                to={settingsData?.twitter_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {/* <svg
                  width="18"
                  height="18"
                  className="socialicon"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_748_16840)">
                    <path
                      d="M16.2122 5.33381C16.2237 5.4937 16.2237 5.65363 16.2237 5.81352C16.2237 10.6904 12.5118 16.3097 5.72747 16.3097C3.63736 16.3097 1.69575 15.7043 0.0625 14.6536C0.359465 14.6879 0.644969 14.6993 0.953359 14.6993C2.67795 14.6993 4.26553 14.1168 5.5333 13.1232C3.91148 13.0889 2.55234 12.0267 2.08405 10.5648C2.3125 10.599 2.54091 10.6219 2.78078 10.6219C3.11199 10.6219 3.44323 10.5762 3.75159 10.4963C2.06124 10.1536 0.793434 8.66884 0.793434 6.87569V6.83003C1.28453 7.10414 1.85564 7.27546 2.46093 7.29827C1.46727 6.63582 0.816285 5.50513 0.816285 4.22593C0.816285 3.54067 0.998992 2.9125 1.31881 2.36427C3.1348 4.60284 5.86451 6.06475 8.92539 6.22467C8.8683 5.95056 8.83402 5.66505 8.83402 5.37952C8.83402 3.3465 10.4787 1.69043 12.5231 1.69043C13.5853 1.69043 14.5447 2.13586 15.2185 2.8554C16.0523 2.69551 16.8518 2.38712 17.5599 1.96454C17.2858 2.82116 16.7033 3.5407 15.9381 3.99752C16.6805 3.91761 17.4 3.71198 18.0624 3.42648C17.56 4.15741 16.9318 4.8084 16.2122 5.33381Z"
                      fill="#141414"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_748_16840">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0.0625)"
                      />
                    </clipPath>
                  </defs>
                </svg> */}
                <svg width="18"
                  height="18"
                  className="socialicon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>
              </Link>
              <Link
                to={settingsData?.instagram_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="19"
                  height="19"
                  className="socialicon"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.0693 5.50781C7.58496 5.50781 5.58105 7.51172 5.58105 9.99609C5.58105 12.4805 7.58496 14.4844 10.0693 14.4844C12.5537 14.4844 14.5576 12.4805 14.5576 9.99609C14.5576 7.51172 12.5537 5.50781 10.0693 5.50781ZM10.0693 12.9141C8.46387 12.9141 7.15137 11.6055 7.15137 9.99609C7.15137 8.38672 8.45996 7.07813 10.0693 7.07813C11.6787 7.07813 12.9873 8.38672 12.9873 9.99609C12.9873 11.6055 11.6748 12.9141 10.0693 12.9141ZM15.7881 5.32422C15.7881 5.90625 15.3193 6.37109 14.7412 6.37109C14.1592 6.37109 13.6943 5.90234 13.6943 5.32422C13.6943 4.74609 14.1631 4.27734 14.7412 4.27734C15.3193 4.27734 15.7881 4.74609 15.7881 5.32422ZM18.7607 6.38672C18.6943 4.98438 18.374 3.74219 17.3467 2.71875C16.3232 1.69531 15.0811 1.375 13.6787 1.30469C12.2334 1.22266 7.90137 1.22266 6.45605 1.30469C5.05762 1.37109 3.81543 1.69141 2.78809 2.71484C1.76074 3.73828 1.44434 4.98047 1.37402 6.38281C1.29199 7.82813 1.29199 12.1602 1.37402 13.6055C1.44043 15.0078 1.76074 16.25 2.78809 17.2734C3.81543 18.2969 5.05371 18.6172 6.45605 18.6875C7.90137 18.7695 12.2334 18.7695 13.6787 18.6875C15.0811 18.6211 16.3232 18.3008 17.3467 17.2734C18.3701 16.25 18.6904 15.0078 18.7607 13.6055C18.8428 12.1602 18.8428 7.83203 18.7607 6.38672ZM16.8936 15.1563C16.5889 15.9219 15.999 16.5117 15.2295 16.8203C14.0771 17.2773 11.3428 17.1719 10.0693 17.1719C8.7959 17.1719 6.05762 17.2734 4.90918 16.8203C4.14355 16.5156 3.55371 15.9258 3.24512 15.1563C2.78809 14.0039 2.89355 11.2695 2.89355 9.99609C2.89355 8.72266 2.79199 5.98438 3.24512 4.83594C3.5498 4.07031 4.13965 3.48047 4.90918 3.17188C6.06152 2.71484 8.7959 2.82031 10.0693 2.82031C11.3428 2.82031 14.0811 2.71875 15.2295 3.17188C15.9951 3.47656 16.585 4.06641 16.8936 4.83594C17.3506 5.98828 17.2451 8.72266 17.2451 9.99609C17.2451 11.2695 17.3506 14.0078 16.8936 15.1563Z"
                    fill="#141414"
                  />
                </svg>
              </Link>

              {/* <Link
                to={settingsData?.instagram_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="19"
                  height="18"
                  className="socialicon"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.71297 15.7496H1.44766V5.23441H4.71297V15.7496ZM3.07855 3.80004C2.03441 3.80004 1.1875 2.9352 1.1875 1.89105C1.1875 1.38952 1.38674 0.908519 1.74138 0.553877C2.09602 0.199236 2.57702 0 3.07855 0C3.58009 0 4.06109 0.199236 4.41573 0.553877C4.77037 0.908519 4.96961 1.38952 4.96961 1.89105C4.96961 2.9352 4.12234 3.80004 3.07855 3.80004ZM16.934 15.7496H13.6757V10.6309C13.6757 9.41098 13.6511 7.84652 11.978 7.84652C10.2803 7.84652 10.0202 9.17191 10.0202 10.543V15.7496H6.75836V5.23441H9.89008V6.66879H9.93578C10.3717 5.84262 11.4366 4.97074 13.0253 4.97074C16.33 4.97074 16.9375 7.14691 16.9375 9.97348V15.7496H16.934Z"
                    fill="#141414"
                  />
                </svg>
              </Link> */}
              <Link
                to={settingsData?.youtube_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="19"
                  height="18"
                  className="socialicon"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_748_16834)">
                    <path
                      d="M17.2413 4.87759C17.045 4.13853 16.4667 3.55647 15.7324 3.35894C14.4015 3 9.06459 3 9.06459 3C9.06459 3 3.72772 3 2.39675 3.35894C1.66247 3.5565 1.08416 4.13853 0.887875 4.87759C0.53125 6.21719 0.53125 9.01213 0.53125 9.01213C0.53125 9.01213 0.53125 11.8071 0.887875 13.1467C1.08416 13.8857 1.66247 14.4435 2.39675 14.6411C3.72772 15 9.06459 15 9.06459 15C9.06459 15 14.4015 15 15.7324 14.6411C16.4667 14.4435 17.045 13.8857 17.2413 13.1467C17.5979 11.8071 17.5979 9.01213 17.5979 9.01213C17.5979 9.01213 17.5979 6.21719 17.2413 4.87759ZM7.31913 11.5497V6.47453L11.7797 9.01219L7.31913 11.5497Z"
                      fill="#141414"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_748_16834">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0.0625)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
